import { Component, OnInit } from '@angular/core';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FeatureFlagsService } from 'src/app/core/shared-service/feature-flags.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { conditions, countryGroups, feature, featureFlags, userGroups } from 'src/app/core/shared-service/feature.flags.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-feature-flags',
  templateUrl: './feature-flags.component.html',
  styleUrls: ['./feature-flags.component.scss']
})
export class FeatureFlagsComponent implements OnInit {
  private showConfirmOnCancel = false;
  private rootScopeData: RootScopeDeclare;
  private featureFlags: featureFlags;
  constructor(
    private facilityService: FacilityService,
    private featureService: FeatureFlagsService,
    private rootScopeService: RootScopeService,
    private loader: HaloLoaderService,
    private amplitudeService: AmplitudeAnalyticsService) { }

  ngOnInit(): void {
    this.getRootScopeData();
    this.featureFlags = this.featureService.FeatureFlags;
  }
  
  private getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => (this.rootScopeData = rootScopeData));
  }

  addNewCondition(feature: feature) {
    this.onEdit();
    feature.conditions.push(new conditions());
  }

  addNewFeature() {
    this.onEdit();
    this.featureFlags.features.push(new feature());
  }

  addNewUserGroup() {
    this.onEdit();
    this.featureFlags.userGroups.push(new userGroups());
  }

  addNewCountryGroup() {
    this.onEdit();
    this.featureFlags.countryGroups.push(new countryGroups());
  }

  addNewData(data: string[]) {
    this.onEdit();
    data.push('');
  }

  onEdit() {
    this.rootScopeData.isPageHasUnsavedChanges = true;
  }

  cancelAll() {
    this.showConfirmOnCancel = true;
  }

  async updateAll() {
    if(this.rootScopeData.isPageHasUnsavedChanges) {
      this.loader.startProcess();
      this.amplitudeService.logEvent({elementName: 'Update', action: 'Click'});
      try {        
        await this.featureService.updateFeatureFlags(this.featureFlags);
        this.facilityService.menu(); 
      } catch (error) {
        console.error("API failed."); 
      }
      this.loader.endProcess();
    }
    this.rootScopeData.isPageHasUnsavedChanges = false;
    this.showConfirmOnCancel = false;
    this.featureFlags = this.featureService.FeatureFlags;
  }

  onIgnoreChanges() {
    this.featureFlags = this.featureService.FeatureFlags;
    this.rootScopeData.isPageHasUnsavedChanges = false;
    this.showConfirmOnCancel = false;
  }

  onKeepChanges() {
    //
  }

  trackIndex(index: number) {
    return index;
  }

}
